"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizerJsonInfo = exports.searchByRegexp = void 0;
const TELCO = 'Telco';
const LEGADO = 'Legado';
const EMPLEADO = 'Empleado';
const GESTOR = 'Gestor';
/**
 * Busca por regexp en la parte correcta del json.
 * @returns {boolean, object} booleano de si lo ha encontrado o no, y objeto encontrado.
 */
const searchByRegexp = (pathname, regexpBranch) => {
    let found = false;
    let object = {};
    let pathNameResult = pathname;
    const keys = Object.keys(regexpBranch);
    let actualOrder = 99999;
    keys.forEach((key) => {
        if (pathname.indexOf(key) >= 0 && regexpBranch[key].order < actualOrder) {
            object = regexpBranch[key];
            actualOrder = regexpBranch[key].order;
            found = true;
            pathNameResult = key;
        }
    });
    return { found, result: object, pathNameResult };
};
exports.searchByRegexp = searchByRegexp;
// export const getDynamicBackLink = (param) => {
//   let result = null;
//   const regexResult = `${window.location.pathname}${window.location.hash}`.match(/\/[0-9]+/);
//   if (regexResult) {
//     [result] = regexResult;
//     return `${param}${result}`;
//   }
// };
const deepSearch = (info, location, userType) => {
    let result = null;
    // 2.1) Miramos por hosts quien sabe... TODO
    if (!result && info && info.hosts && info.hosts[location.host]) {
        if (info.hosts[location.host][location.pathname]) {
            result = info.hosts[location.host][location.pathname];
        }
        else {
            result = info.hosts[location.host]['/'];
        }
    }
    // 2.2) Miramos en logado por ambos mundos
    if (!result &&
        (userType === 'Telco' || userType === 'Gestor') &&
        info &&
        info.tcol &&
        info.tcol[location.pathname]) {
        result = info.tcol[location.pathname];
    }
    // 2.3) Lets check on gp
    if (!result && info && info.colx && info.colx[location.pathname]) {
        result = info.colx[location.pathname];
    }
    // 2.4) Miramos por regex xk viendo el plan a saber
    let regexResult = null;
    if (!result && info && info.regexp) {
        regexResult = (0, exports.searchByRegexp)(location.pathname, info.regexp);
        if (regexResult && regexResult.found && regexResult.pathNameResult) {
            ({ result } = regexResult);
        }
    }
    // reviso si tiene un dynamic back link por is las moscas
    // if (result && result.dynamicBackLink && result.backLink) {
    //   // TODO en vista const realBackLink = getDynamicBackLink(result.backLink);
    //   if (realBackLink) {
    //     result.backLink = realBackLink;
    //   }
    // }
    // 2.5) Miramos a ver si es el default
    if (result &&
        result.type !== 'none' &&
        !(userType === 'Gestor') &&
        info &&
        info['default-options'] &&
        (!result ||
            !result.type ||
            (result && result.type && result.type === 'default'))) {
        result = Object.assign(Object.assign({}, result), { type: 'default', defaultOptions: info['default-options'] });
    } // main -->default options
    return result;
};
const normalizerJsonInfo = ({ info, userType = '', // esto vendra ['Legado','Telco','Gestor','Empleado', ""]
location = {
    host: 'movistar.es',
    pathname: '/particulares',
}, }) => {
    // 1.1) logo
    let logo = null;
    if (info && info.logo) {
        ({ logo } = info);
    }
    const movistarMenuInfo = {
        logo,
        menu: null,
        modalProps: null,
    };
    // 1.2) TODO Getting the rightmenu for (only first tiem control with yield select)
    if (info && info.titleBar && info.titleBar.options) {
        const { titleBar } = info;
        const { options } = titleBar;
        // se puede reducir a una linea indexando bien
        if (userType === EMPLEADO) {
            movistarMenuInfo.menu = options.empleado;
        }
        else if (userType === TELCO) {
            movistarMenuInfo.menu = options.telco;
        }
        else if (userType === LEGADO) {
            movistarMenuInfo.menu = options.legado;
        }
        else if (userType === GESTOR) {
            movistarMenuInfo.menu = options.gestor;
        }
        else {
            movistarMenuInfo.menu = options.colx;
        }
    }
    // 1.3) Getting modalProps TODO only first time
    const modalProps = {};
    if (info && info.modalLogin) {
        modalProps.login = info.modalLogin;
    }
    if (info && info.modalSearch) {
        modalProps.search = info.modalSearch;
    }
    if (info && info.modalSupport) {
        modalProps.support = info.modalSupport;
    }
    movistarMenuInfo.modalProps = modalProps;
    // 1.4) SEND TO REDUCER
    // yield put(easyHeaderActions.setStateData({ key: 'movistarMenuInfo', value: movistarMenuInfo }));
    // 2) LETS EXTRACT sectionMenu
    let newSectionMenu = null;
    let result = deepSearch(info, location, userType);
    // 2.5) el tema del type se analiza al final
    while (result &&
        (result.type === 'reference' || // redirection
            result.type === 'territoryReference' || // redirection
            result.pathNameResult) // redirection
    ) {
        let newPathName = '';
        if (result.referenceTo) {
            newPathName = result.referenceTo;
        }
        if (result.pathNameResult) {
            newPathName = result.pathNameResult;
        }
        result = deepSearch(info, {
            host: location.host,
            pathname: newPathName,
        }, userType);
    }
    newSectionMenu = result; // viene del json
    return {
        sectionMenu: newSectionMenu,
        movistarMenuInfo,
    };
};
exports.normalizerJsonInfo = normalizerJsonInfo;
//# sourceMappingURL=utils.js.map